import { Pipe, PipeTransform, SecurityContext } from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'
import { encode } from 'html-entities'
import { DevBarService } from '../services/dev-bar.service.js'
import { HtmlMode } from '@lg/shared'

const cache = new Map<string, SafeHtml>()
// regex must match HTML produced by AngularLabelCompiler! Important: exclude ' from moduleId and boId capturing groups to prevent security issues!
const translationSpanRegex =
	/<span role="translateLabel:(?<moduleId>[^"'.]*).(?<boId>[^"']*)" (?<rest>class="[^"]*" title="[^"]*")>/g
function getTranslationSpanReplacement(match: any) {
	return `<span onclick="event.preventDefault(); event.stopPropagation(); document.dispatchEvent(new CustomEvent('translateLabel', { detail: { moduleId: '${match.moduleId}', boId: '${match.boId}' } }))" ${match.rest}>`
}

@Pipe({
	name: 'escapeHtml',
	standalone: false,
})
export class EscapeHtmlPipe implements PipeTransform {
	constructor(
		private domSanitizer: DomSanitizer,
		private devBarService: DevBarService,
	) {}

	transform(value: any, htmlMode: HtmlMode = 'none') {
		const cacheKey = `${value}|${htmlMode}`
		if (cache.has(cacheKey)) return cache.get(cacheKey)!
		if (!value) return value
		if (typeof value != 'string') value = String(value)

		const hasTranslationSpan = value.includes('<span role="translateLabel:')

		if (htmlMode == 'none' && !hasTranslationSpan) return encode(value)

		let sanitizedValue =
			htmlMode === 'unsafe'
				? value
				: this.domSanitizer.sanitize(SecurityContext.HTML, value)

		if (this.devBarService.canUseDevBar() && hasTranslationSpan) {
			// replace allowed HTML role attribute with prohibitec onclick handler
			sanitizedValue = sanitizedValue.replace(
				translationSpanRegex,
				(...args: any[]) => {
					const groups = args.at(-1)
					return getTranslationSpanReplacement(groups)
				},
			)
		}

		const safeHtml = this.domSanitizer.bypassSecurityTrustHtml(sanitizedValue)
		cache.set(cacheKey, safeHtml)
		return safeHtml
	}
}
